import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Accordion,
  Dropdown,
  DropdownButton,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaEdit, FaPlus, FaTrashAlt, FaFileImport } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Pagination from "../../components/Pagination";
import CommonButton from "../../components/CommonButton";
import NoData from "../../components/NoData";
import StockModal from "../../components/Modals/StockModal";
import ImportModal from "../../components/Modals/ImportModel";
import InventoryViewModal from "../../components/Modals/HisstoryModals/InventoryViewModal";
import { BASE_URL, HEADERS } from "../../utils/constant";

const InventoryList = () => {
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [showAddStockModal, setShowAddStockModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);
  const [selectedStockId, setSelectedStockId] = useState(null);
  const [modalMode, setModalMode] = useState("add");

  const userPermissions = localStorage.getItem("user_permissions") || "";

  useEffect(() => {
    fetchStocks(currentPage);
  }, [currentPage, itemsPerPage, searchText]);

  const fetchStocks = async (page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/inventory/`, {
        headers: HEADERS,
        params: {
          page,
          page_size: itemsPerPage,
          search: searchText || "",
        },
      });
      setStocks(response.data.results || []);
      setTotalPages(response.data.total_pages || 1);
      setCurrentPage(page);
    } catch (error) {
      // toast.error("Failed to fetch inventory.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleAddStock = () => {
    setSelectedStock(null);
    setModalMode("add");
    setShowAddStockModal(true);
  };

  const handleEditStock = (stock) => {
    setSelectedStock(stock);
    setModalMode("edit");
    setShowAddStockModal(true);
  };

  const handleAddQuantity = (stock) => {
    setSelectedStock(stock);
    setModalMode("addQuantity");
    setShowAddStockModal(true);
  };

  const handleViewStock = (stockId) => {
    setSelectedStockId(stockId);
    setShowViewModal(true);
  };

  const handleDeleteStock = async (stockId) => {
    try {
      await axios.delete(`${BASE_URL}/api/inventory/${stockId}/`, {
        headers: HEADERS,
      });
      toast.success("Stock deleted successfully!");
      fetchStocks(currentPage);
    } catch (error) {
      toast.error("Failed to delete stock.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="mt-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">Inventory</h4>

        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            value={searchText}
            placeholder="Search Here..."
            className="uniform-input search-text"
            onChange={(e) => setSearchText(e.target.value)}
          />
          <CommonButton onClick={handleAddStock}>
            <FaPlus className="me-2" /> Add
          </CommonButton>
          <CommonButton
            variant="secondary"
            onClick={() => setShowImportModal(true)}
          >
            <FaFileImport className="me-2" /> Import
          </CommonButton>
        </div>

        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body>
                <div className="d-flex flex-column gap-3">
                  <Form.Control
                    type="text"
                    value={searchText}
                    placeholder="Search Here..."
                    className="uniform-input"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <CommonButton
                    className="w-100 d-flex align-items-center justify-content-center"
                    onClick={handleAddStock}
                  >
                    <FaPlus className="me-2" /> Add
                  </CommonButton>
                  <CommonButton
                    variant="secondary"
                    className="w-100 d-flex align-items-center justify-content-center"
                    onClick={() => setShowImportModal(true)}
                  >
                    <FaFileImport className="me-2" /> Import
                  </CommonButton>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${stocks.length === 0 ? "" : "tabell"}`}
      >
        {loading ? (
          <Loader />
        ) : stocks.length > 0 ? (
          <table className="table tstart align-middle">
            <thead className="thead">
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ width: "100px" }}>ID</th>
                <th style={{ width: "200px" }}>Date</th>
                <th style={{ width: "250px" }}>Item</th>
                <th style={{ width: "350px" }}>Description</th>
                <th style={{ width: "150px" }}>Quantity</th>
                <th style={{ width: "200px" }}>Created By</th>
                <th style={{ width: "200px" }}>Updated By</th>
                <th style={{ width: "150px" }}></th>
              </tr>
            </thead>

            <tbody>
              {stocks.map((stock) => (
                <tr
                  key={stock.id}
                  onClick={() => handleViewStock(stock.id)}
                  className="tbody"
                  style={{ cursor: "pointer" }}
                >
                  <td>
                    <span className="badge bg-primary text-white me-2">
                      {stock.id}
                    </span>
                  </td>
                  <td>
                    <div title={stock.created_at || "—"} className="tdsubject">
                      {stock.created_at || "—"}
                    </div>
                  </td>
                  <td>
                    <div title={stock.item || "—"} className="tdsubject">
                      {stock.item || "—"}
                    </div>
                  </td>
                  <td>
                    <div title={stock.description || "—"} className="tdsubject">
                      {stock.description || "—"}
                    </div>
                  </td>
                  <td>
                    <div title={stock.quantity || "0"} className="tdsubject">
                      <span className="badge bg-secondary">
                        {stock.quantity || "0"}
                      </span>
                    </div>
                  </td>

                  <td>
                    <div
                      title={
                        stock?.created_by
                          ? typeof stock.created_by === "object" &&
                            stock.created_by !== null
                            ? `${stock.created_by.first_name || ""} ${
                                stock.created_by.last_name || ""
                              }`.trim()
                            : stock.created_by
                          : "—"
                      }
                      className="tdsubject"
                    >
                      {stock?.created_by &&
                      typeof stock.created_by === "object" &&
                      stock.created_by !== null
                        ? `${stock.created_by.first_name || ""} ${
                            stock.created_by.last_name || ""
                          }`.trim() || "—"
                        : stock?.created_by || "—"}
                    </div>
                  </td>

                  <td>
                    <div
                      title={
                        stock?.updated_by
                          ? typeof stock.updated_by === "object" &&
                            stock.updated_by !== null
                            ? `${stock.updated_by.first_name || ""} ${
                                stock.updated_by.last_name || ""
                              }`.trim()
                            : stock.updated_by
                          : "—"
                      }
                      className="tdsubject"
                    >
                      {stock?.updated_by &&
                      typeof stock.updated_by === "object" &&
                      stock.updated_by !== null
                        ? `${stock.updated_by.first_name || ""} ${
                            stock.updated_by.last_name || ""
                          }`.trim() || "—"
                        : stock?.updated_by || "—"}
                    </div>
                  </td>
                  <td>
                    <div className="ms-auto">
                      <DropdownButton
                        id="dropdown-basic-button"
                        title={<BsThreeDotsVertical />}
                        variant="link"
                        className="p-0 text-secondary custom-dropdown"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditStock(stock);
                          }}
                        >
                          <FaEdit className="me-2" /> Edit
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAddQuantity(stock);
                          }}
                        >
                          <FaPlus className="me-2" /> Add Qty
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteStock(stock.id);
                          }}
                          className="text-danger"
                        >
                          {loading ? (
                            <span>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-2"
                              />
                              Deleting...
                            </span>
                          ) : (
                            <>
                              <FaTrashAlt className="me-2" /> Delete
                            </>
                          )}
                        </Dropdown.Item>
                      </DropdownButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoData message="No Inventory Found" height="400px" />
        )}
      </div>
      {stocks.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}
      {showAddStockModal && (
        <StockModal
          show={showAddStockModal}
          handleClose={() => setShowAddStockModal(false)}
          onAdd={() => fetchStocks(currentPage)}
          currentStock={selectedStock}
          mode={modalMode}
        />
      )}

      {showImportModal && (
        <ImportModal
          show={showImportModal}
          type="stock"
          handleClose={() => setShowImportModal(false)}
          onSuccess={() => fetchStocks(currentPage)}
        />
      )}

      {showViewModal && (
        <InventoryViewModal
          show={showViewModal}
          handleClose={() => setShowViewModal(false)}
          stockId={selectedStockId}
        />
      )}
    </div>
  );
};

export default InventoryList;
